"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var messageStart = document.querySelector(".message-start");
var messageLose = document.querySelector(".message-lose");
var messageWin = document.querySelector(".message-win");
var score = document.querySelector(".game-score");
var button = document.querySelector(".button");
var rows = 4;
var columns = 4;
var board;
var scoreCount = 0;
var won = false;
button.addEventListener("click", function(e) {
    messageStart.classList.add("hidden");
    button.innerText = "Restart";
    button.classList.replace("start", "restart");
    setGame();
});
button.addEventListener("click", function(e) {
    messageWin.classList.add("hidden");
    won = false;
    clearBoard();
    setGame();
});
function setGame() {
    board = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ];
    setTile();
    setTile();
}
function hasEmptyTile() {
    for(var r = 0; r < rows; r++)for(var c = 0; c < columns; c++){
        if (board[r][c] === 0) return true;
    }
    return false;
}
function loseGame() {
    if (hasEmptyTile()) return false;
    for(var i = 0; i < rows; i++)for(var j = 0; j < rows; j++){
        if (board[i][j] === board[i][j + 1]) return false;
    }
    for(var i1 = 0; i1 < rows - 1; i1++)for(var j1 = 0; j1 < rows; j1++){
        if (board[i1][j1] === board[i1 + 1][j1]) return false;
    }
    return true;
}
function clearBoard() {
    board.forEach(function(row, r) {
        row.forEach(function(cell, c) {
            var tile = document.getElementById(r.toString() + "-" + c.toString());
            tile.innerText = "";
            tile.classList.value = "";
            tile.classList.add("field-cell");
            score.innerText = 0;
            scoreCount = 0;
        });
    });
}
function setTile() {
    if (!hasEmptyTile()) return;
    var found = false;
    var numb = Math.random() < 0.9 ? 2 : 4;
    while(!found){
        var r = Math.floor(Math.random() * rows);
        var c = Math.floor(Math.random() * columns);
        if (board[r][c] === 0) {
            board[r][c] = numb;
            var tile = document.getElementById(r.toString() + "-" + c.toString());
            tile.innerText = "".concat(numb);
            tile.classList.add("field-cell--" + numb.toString());
            found = true;
        }
    }
    if (loseGame()) {
        messageLose.classList.remove("hidden");
        button.addEventListener("click", function() {
            messageLose.classList.add("hidden");
            clearBoard();
            setGame();
        });
    }
}
function updateTile(r, c) {
    var tile = document.getElementById(r.toString() + "-" + c.toString());
    var num = board[r][c];
    tile.innerText = "";
    tile.classList.value = "";
    tile.classList.add("field-cell");
    if (num > 0) {
        tile.innerText = num.toString();
        tile.classList.add("field-cell--" + num.toString());
    }
    if (num === 2048) {
        messageWin.classList.remove("hidden");
        won = true;
    }
}
document.addEventListener("keyup", function(e) {
    e.preventDefault();
    if (won) return;
    switch(e.key){
        case "ArrowLeft":
            slideLeft();
            break;
        case "ArrowRight":
            slideRight();
            break;
        case "ArrowUp":
            slideUp();
            break;
        case "ArrowDown":
            slideDown();
            break;
    }
});
function filterZero(row) {
    return row.filter(function(num) {
        return num !== 0;
    });
}
function slide(newRow) {
    var row = newRow;
    row = filterZero(row);
    for(var i = 0; i < row.length - 1; i++)if (row[i] === row[i + 1]) {
        row[i] *= 2;
        row[i + 1] = 0;
        scoreCount += row[i];
        score.innerText = scoreCount;
    }
    row = filterZero(row);
    while(row.length < columns)row.push(0);
    return row;
}
function slideLeft() {
    var initialBoard = board.map(function(row) {
        return _to_consumable_array(row);
    });
    for(var r = 0; r < rows; r++){
        var row = board[r];
        row = slide(row);
        board[r] = row;
        for(var c = 0; c < columns; c++)updateTile(r, c);
    }
    if (hasChanges(initialBoard, board)) setTile();
}
function slideRight() {
    var initialBoard = board.map(function(row) {
        return _to_consumable_array(row);
    });
    for(var r = 0; r < rows; r++){
        var row = board[r];
        row.reverse();
        row = slide(row);
        board[r] = row.reverse();
        for(var c = 0; c < columns; c++)updateTile(r, c);
    }
    if (hasChanges(initialBoard, board)) setTile();
}
function slideUp() {
    var initialBoard = board.map(function(row) {
        return _to_consumable_array(row);
    });
    for(var c = 0; c < columns; c++){
        var row = [
            board[0][c],
            board[1][c],
            board[2][c],
            board[3][c]
        ];
        row = slide(row);
        for(var r = 0; r < rows; r++){
            board[r][c] = row[r];
            updateTile(r, c);
        }
    }
    if (hasChanges(initialBoard, board)) setTile();
}
function slideDown() {
    var initialBoard = board.map(function(row) {
        return _to_consumable_array(row);
    });
    for(var c = 0; c < columns; c++){
        var row = [
            board[0][c],
            board[1][c],
            board[2][c],
            board[3][c]
        ];
        row.reverse();
        row = slide(row);
        row.reverse();
        for(var r = 0; r < rows; r++){
            board[r][c] = row[r];
            updateTile(r, c);
        }
    }
    if (hasChanges(initialBoard, board)) setTile();
}
function hasChanges(arrayA, arrayB) {
    for(var i = 0; i < arrayA.length; i++)for(var j = 0; j < arrayA[i].length; j++){
        if (arrayA[i][j] !== arrayB[i][j]) return true;
    }
    return false;
}

//# sourceMappingURL=index.1a8bb56b.js.map
